import React, { useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import NotifCard from "components/datadisplay/cards/NotifCard";
import { ApiUrls } from "services/utils/globalVariables";
import useFetch from "services/hooks/useFetch";
import { PageHeading } from "components/typography/text";
import { NotifCardLoader } from "components/loaders/NotifLoaders";

export default function NotificationPage() {

    const [{ response, isLoading, error }, doFetch] = useFetch(ApiUrls.GetNotificationByUser, "get")

    useEffect(() => {
        doFetch()
    }, [])

    return (
        <Stack sx={{direction: "ltr !important"}}>
            <Stack spacing={2} sx={{mt: 3, padding: "0 16px"}}>
                <PageHeading>اعلان ها</PageHeading>
                <Stack spacing={2} sx={{width: "100%"}} >
                    {
                        isLoading ?
                            <>
                                {
                                    response.Data.length > 0 ?
                                        response.Data.map((val, i) => {
                                            return (
                                                <NotifCard key={i} data={val} />
                                            )
                                        })
                                    : 
                                        <Stack sx={{width: "100%", py: 2}}>
                                            <Typography sx={{color: "grey", textAlign: "center", fontSize: "18px"}}>موردی وجود ندارد</Typography>
                                        </Stack>
                                }
                            </>
                        : <NotifCardLoader />
                    }
                </Stack>
            </Stack>
        </Stack>
    )
}